module.exports = __webpack_public_path__ + "static/media/tm-color.859c5eea.webp";